import { enableProdMode, Injector } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import {
  configLoader,
  ServerConfigService,
} from '@app/configuration/server-config.service';
import { ConsoleLoggerService } from '@features/logging/console.logger.service';
import { LoggerService } from '@features/logging/logger.service';
import * as LogRocket from 'logrocket';
import { AppModule } from './app/app.module';

const injector = Injector.create({
  providers: [
    { provide: ServerConfigService, deps: [] },
    { provide: LoggerService, useClass: ConsoleLoggerService, deps: [] },
  ],
});
const serverConfigService = injector.get(ServerConfigService);
const loggerService = injector.get(LoggerService);

function bootstrap() {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => loggerService.error(err));
}

function enableLogRocket() {
  LogRocket.init('5rwrk3/imcc-dev');
}

const environmentSetup = {
  local: bootstrap,
  test: () => {
    enableLogRocket();
    bootstrap();
  },
  prod: () => {
    enableLogRocket();
    enableProdMode();
    bootstrap();
  },
  ppe: () => {
    enableLogRocket();
    enableProdMode();
    bootstrap();
  },
};

if (
  navigator.userAgent.indexOf('MSIE') !== -1
    || navigator.appVersion.indexOf('Trident/') > -1
) {
  loggerService.warn(
    `Unsupported MSIE browser detected  ${navigator.userAgent}`,
  );
} else {
  configLoader
    .then(() => {
      const { config } = serverConfigService;
      environmentSetup[config.nodeEnv](config);
    })
    .catch((error) => loggerService.warn(error));
}
